import React from "react";
import { styled, css } from "styled-components";
import InputText from "../Text/InputText";
import Label from "../Text/Label";
import { ArrivalDate, DepartureDate } from "../../icons";
import Colors from "../../styles/Colors";
import rem from "../../utils/rem";
const TravelWay = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: ${rem(18)};
  > svg {
    margin-right: ${rem(14)};
  }
  h6 {
    margin: 0;
  }
  p {
    margin: 0;
  }
`;
const TravelInformationWrapper = styled.div `
  ${({ borderWrap }) => borderWrap &&
    css `
      border: 1px solid ${Colors.LIGHT_RED_2024};
      background: ${Colors.WHITE_2024};
      padding-top: 1.125rem;
      padding: 1.125rem 1.125rem 0 1.125rem;
      border-radius: 5px;
    `}
`;
export const TravelInformation = ({ outbound, inbound, borderWrap = false, }) => {
    const iconSize = 30;
    return (React.createElement(TravelInformationWrapper, { borderWrap: borderWrap },
        outbound && (React.createElement(TravelWay, null,
            React.createElement(DepartureDate, { width: iconSize, height: iconSize }),
            React.createElement("div", null,
                React.createElement(Label, { as: "h6" }, `${outbound.from} - ${outbound.to}`),
                React.createElement(InputText, null, outbound.date)))),
        inbound && (React.createElement(TravelWay, null,
            React.createElement(ArrivalDate, { width: iconSize, height: iconSize }),
            React.createElement("div", null,
                React.createElement(Label, { as: "h6" }, `${inbound.from} - ${inbound.to}`),
                React.createElement(InputText, null, inbound.date))))));
};
export default TravelInformation;
//# sourceMappingURL=TravelInformation.js.map